@if (conduitLengthForm) {
  <form
    odxForm
    [formGroup]="conduitLengthForm"
    [readonly]="
      (isReferenceMeasureSet$ | async) === false ||
      (isReadOnlyUser$ | async) === true ||
      (hasWritePermission$ | async) === false ||
      conduit.locked
    "
  >
    <odx-form-field i18n-label="@@floorplan.details.form.item.name.lengthInMeter" label="Länge (Meter)">
      <input
        formControlName="referenceLength"
        type="number"
        odxFormFieldControl
        min="0.1"
        step="0.9"
        i18n-placeholder="@@floorplan.details.form.length.unit.meter"
        placeholder="Länge"
        [odxTooltip]="tooltipTextNoReferenceMeasure"
        [odxTooltipDisabled]="(isReferenceMeasureSet$ | async) === true"
      />
    </odx-form-field>
  </form>
}
